import React, {createContext, useContext, useEffect, useReducer} from "react";
import {consumerReducer} from "../reducers/consumerReducer";
import {CONSUMER_INIT_STATE} from "../utils/constants";
import {differenceInHours} from "date-fns";

const ConsumerContext = createContext(null);

let initConsumerData;
try {
    let sessionData = JSON.parse(sessionStorage.getItem("_consumerData"));
    initConsumerData = (sessionData && sessionData.crtDate && differenceInHours(new Date(), new Date(sessionData.crtDate)) < 2) ? sessionData : CONSUMER_INIT_STATE;
} catch {
    initConsumerData = {};
}

export function ConsumerProvider({children}) {
    const [consumerData, dispatch] = useReducer(consumerReducer, initConsumerData);
    useEffect(() => sessionStorage.setItem("_consumerData", JSON.stringify(consumerData)), [consumerData])
    const consContext = {consumerData, dispatch};
    return (
        <ConsumerContext.Provider value={consContext}>
            {children}
        </ConsumerContext.Provider>
    );
}

export function useConsumerContext() {
    const cntxt = useContext(ConsumerContext);
    return cntxt ? cntxt : undefined;
}